// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1arzd","list":"BalanceDue_list__VrqwG","listRow":"BalanceDue_listRow__3o4Km","total":"BalanceDue_total__LkD2j"};